import React, { createContext, ReactNode, useContext, useRef } from "react";

interface SearchContextType {
    focusSearch: () => void;
    registerSearchBox: (ref: React.RefObject<HTMLInputElement>) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export function useSearchContext() {
    const context = useContext(SearchContext);
    if (!context) {
        throw new Error("useSearchContext must be used within a SearchProvider");
    }
    return context;
}

interface SearchProviderProps {
    children: ReactNode;
}

export function SearchProvider({ children }: SearchProviderProps) {
    const searchInputRef = useRef<React.RefObject<HTMLInputElement> | null>(null);

    const registerSearchBox = (ref: React.RefObject<HTMLInputElement>) => {
        searchInputRef.current = ref;
    };

    const focusSearch = () => {
        if (searchInputRef.current?.current) {
            searchInputRef.current.current.focus();
            // Optionnel : scroll vers la SearchBox si elle n'est pas visible
            searchInputRef.current.current.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });
        }
    };

    const value = {
        focusSearch,
        registerSearchBox
    };

    return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
}
